import asyncRetry from "async-retry";
// src/Retry/retry.ts
var RETRY_OPTIONS = {
	retries: 4,
	minTimeout: 200
};
async function retry(resolver, options = {}) {
	return asyncRetry(resolver, {
		...RETRY_OPTIONS,
		...options
	});
}
export { retry as t };

//# sourceMappingURL=Retry-CZPIiI0H.js.map